import React, { useRef, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import mouseWheelZoom from "highcharts/modules/mouse-wheel-zoom";
import { useSelector } from "react-redux";
import { CompactTagValueDynamic } from "../../CompactValue/CompactValue";
mouseWheelZoom(Highcharts);

export function BarChartBPCL({ countData, activeSwitches }) {
  const chartRef = useRef(null);

  const { selectBPCLUnits } = useSelector(
    (state) => state.dateSliceprocessDashboardState
  );

  const validCountData = Array.isArray(countData) ? countData : [];

  const isLiveDataPresent = validCountData.some((item) => item.type === "live");

  const getColorForPlant = (plantId) => {
    const activeSwitch = activeSwitches.find(
      (switchObj) => switchObj.id === plantId
    );
    return activeSwitch ? activeSwitch.color : "#9B64B7"; // Default color if not found
  };

  const dataWithColors = countData.map((plant) => ({
    y: isLiveDataPresent
      ? parseFloat(CompactTagValueDynamic(selectBPCLUnits, plant.value))
      : parseFloat(plant.value),
    // selectBPCLUnits == "k"
    //   ? plant?.generation_value_in_kilo
    //   : selectBPCLUnits == "m"
    //   ? plant?.generation_value
    //   : plant?.generation_value_in_giga,
    color: getColorForPlant(plant.id), // Use color based on plant ID
  }));

  const categories = countData?.map((plant) => plant.name);

  const options = {
    chart: {
      zooming: { mouseWheel: { enabled: true, type: "x" } },
      type: "column",
      height: 230,
      width: 230,
      backgroundColor: "transparent",
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: categories,
      labels: {
        enabled: false,
      },

      max: 4,
    },
    scrollbar: {
      enabled: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "MW",
      },
    },
    series: [
      {
        name: "Generation",
        data: dataWithColors,
      },
    ],
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
  };

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.chart.update(options);
    }
  }, [countData, activeSwitches, selectBPCLUnits]); // Re-run effect when countData or activeSwitches change

  return (
    <div
      style={{
        width: "100%",
        height: "195px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        ref={chartRef}
      />
    </div>
  );
}
